export const mapEase = (ease) => {
	if (!ease) return "none";
	// If user already passed a complex gsap ease (e.g. power2.inOut or elastic.out(...)) keep it.
	if (ease === "none" || /[.(]/.test(ease)) return ease;
	switch (ease) {
		case "linear":
			return "none";
		case "ease":
			return "power2.inOut";
		case "elastic":
			return "elastic.out(1,0.5)"; // mild elastic
		default:
			return ease; // fallback pass-through
	}
};
